import MDBox from "../../../components/MDBox";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import MDTypography from "../../../components/MDTypography";
import {
    Chip,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    FormControl,
    Skeleton
} from "@mui/material";
import MDInput from "../../../components/MDInput";
import Autocomplete from "@mui/material/Autocomplete";
import Button from "@mui/material/Button";
import {MuiDataGrid} from "../../../components/MuiDatagrid";
import {
    GridToolbar,
    GridToolbarColumnsButton,
    GridToolbarContainer,
    GridToolbarDensitySelector, GridToolbarExport,
    GridToolbarFilterButton
} from "@mui/x-data-grid";
import { zhCN,enUS } from '@mui/x-data-grid/locales';
import moment from "moment";
import CustomerEditor from "../CustomerEditor";
import MDButton from "../../../components/MDButton";
import LocalStorage from "../../../utils/LocalStorage";
import {removeCustomer} from "../../../actions/customer/customerAction";
import {
    change_Customer_Active, customerFilter, InventoryActionType,
    ownerFilter,
    ownerSelected
} from "../../../actions/inventory/inventoryAction";
import Fade from "@mui/material/Fade";
import React, {memo, useEffect, useRef, useState} from "react";
import {useTranslation} from "react-i18next";
import {useDebounce} from "use-debounce";
import {useNavigate} from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";
import {Logout, onErrorAlert, onSuccessAlert, requisitionFilter} from "../../../actions";
import {isEqual, noop, throttle} from "lodash";
import Tooltip from "@mui/material/Tooltip";
import IconButton from "@mui/material/IconButton";
import Icon from "@mui/material/Icon";
import { v4 as uuidv4 } from 'uuid';
import OwnerCargoPreviewer from "./OwnerCargoPreviewer";
import CleaningServicesIcon from "@mui/icons-material/CleaningServices";
import {checkPermission, PERMISSION_DICT} from "../../../utils/Users_Roles_Permission";
import {COLUMN_WIDTH} from "../../../constants";
import CurrentStateLoading from "../../../examples/Loading/CurrentStateLoading";
import {CustomToolbar} from "../../../utils/globalFunction";
import {MaterialReactTable, useMaterialReactTable} from "material-react-table";
import {download, generateCsv, mkConfig} from "export-to-csv";
import DownloadIcon from "@mui/icons-material/Download";
import {LoadingButton} from "@mui/lab";
import {MRT_Localization_EN} from "material-react-table/locales/en";
import {MRT_Localization_ZH_HANS} from "material-react-table/locales/zh-Hans";
import {MRT_Localization_FR} from "material-react-table/locales/fr";

const invoiceTermOptions = [
    {value: '1', label: 'Daily Settlement'},
    {value: '7', label: 'Weekly Settlement'},
    {value: '15', label: 'Semimonthly Settlement'},
    {value: '30', label: 'Monthly Settlement'}
]

const getInvoiceTermLabel = (value) => {
    if (value === null || value === undefined || value === '') return ''

    const text = value.toString().trim()
    const option = invoiceTermOptions.find(
        item => item.value === text || item.label === text
    )

    return option?.label || text
}

const OwnerCargo = memo(() => {
    const {t, i18n} = useTranslation();
    const [condition, setCondition] = useState('')
    const [isActive, setIsActive] = useState(null)
    const [loading, setLoading] = useState(false)
    const [value] = useDebounce(condition, 800);
    const [pagination, setPagination] = useState({
        pageIndex: 0,
        pageSize: 50, //customize the default page size
    });
    const [rowSelection, setRowSelection] = useState({});
    const nav = useNavigate()
    const dispatch = useDispatch()
    const languageSelect = useSelector(state => state?.common?.language,(prev, next) => prev === next)
    const [total,setTotal] = useState(0)
    const [data,setData] = useState([])
    const [isOpen, setIsOpen] = useState(false)
    const [transferData, setTransferData] = useState({})
    const [type, setType] = useState('Add')
    const [currentRow,setCurrentRow] = useState({})
    const [isAlertOpen, setIsAlertOpen] = useState(false)

    const [ownerList ,setOwnerList] =useState([])
    const [owner,setOwner] = useState([])
    const [inputOwnerValue,setInputOwnerValue] = useState()
    const [ownerValue] = useDebounce(inputOwnerValue, 500);
    const [triggerFetch, setTriggerFetch] = useState(false);
    const lastPayloadRef = React.useRef(null);
    const initialLoad = React.useRef(true);
    const col = { left: ['mrt-row-select','mrt-row-numbers','ownerId' ,'ocpOwnerId','mrt-row-actions'] , right: ['activeAction']}
    const mobileCol = { left: ['mrt-row-numbers','mrt-row-actions'] }
    const mdCol = {  left: ['mrt-row-numbers','ocpOwnerId','mrt-row-actions']}
    const [exportLoading,setExportLoading] = useState(false)

    const PAGE_KEY = 'customer-cargo-owner'
    const MOBILE_WIDTH = 600;
    const TABLET_WIDTH = 960;
    const getStoredColumnPinning = () => {
        const storedData = JSON.parse(localStorage.getItem("columnPinning")) || {};
        return storedData[PAGE_KEY] || null;
    };

    const [columnPinning, setColumnPinning] = useState(() => {
        const storedValue = getStoredColumnPinning();
        if (storedValue) return storedValue;

        // 按照默认逻辑走
        const width = window.innerWidth;
        if (width < MOBILE_WIDTH) return mobileCol;
        if (width < TABLET_WIDTH) return mdCol;
        return col;
    });

    useEffect(() => {
        const storedData = JSON.parse(localStorage.getItem("columnPinning")) || {};
        if (JSON.stringify(storedData[PAGE_KEY]) !== JSON.stringify(columnPinning)) {
            storedData[PAGE_KEY] = columnPinning;
            localStorage.setItem("columnPinning", JSON.stringify(storedData));
        }
    }, [columnPinning]);
    const [columnVisibility, setColumnVisibility] = useState(() => {
        const storedData = JSON.parse(localStorage.getItem('columnVisibility')) || {};
        return storedData[PAGE_KEY] || {
            lotId: false,
            alternativeId:false,
            financerEmail:false,
            noteText:false,
            ownerDesc2:true,
            financerEmail:true,
            noteText:true
        }; // 读取当前页面的列可见性
    })

    useEffect(() => {
        // 每次用户更改列显示状态时，存储到 localStorage
        const storedData = JSON.parse(localStorage.getItem('columnVisibility')) || {};
        storedData[PAGE_KEY] = columnVisibility; // 更新当前页面的列可见性
        localStorage.setItem('columnVisibility', JSON.stringify(storedData));
    }, [columnVisibility]);

    const headerRef = useRef(null);
    const [tableHeight, setTableHeight] = useState(640);

    useEffect(() => {
        const updateTableHeight = () => {
            if (headerRef.current) {
                const headerTop = headerRef.current.getBoundingClientRect().top;
                const newHeight = window.innerHeight - headerTop - 90;
                setTableHeight(newHeight > 200 ? newHeight : 200);
            }
        };

        const resizeObserver = new ResizeObserver(updateTableHeight);
        if (headerRef.current) {
            resizeObserver.observe(headerRef.current);
        }

        updateTableHeight(); // 初始化计算

        return () => resizeObserver.disconnect();
    }, []);

    const activeArr = [
        {
            id: 1,
            value: 'Y',
            label: `${t(`ProductPage.OPEN`)}`,
            color: "#4caf50",
            bg: "#dcfce7",
        },
        {
            id: 2,
            value: 'N',
            label: `${t(`ProductPage.CLOSED`)}`,
            color: "#ef4444",
            bg: "#fee2e2",
        },
        {
            id: 3,
            value: 'C',
            label: `${t(`ProductPage.CREATED`)}`,
            color: "#3b82f6",
            bg: "#eff6ff",
        },
        {
            id: 4,
            value: 'T',
            label: 'TERMINATED',
            color: "#6b7280",
            bg: "#f3f4f6",
        },

    ]

    useEffect(() => {
        return () => {
            lastPayloadRef.current = null
            initialLoad.current = true
            setTotal(0)
            setData([])
        };
    }, [dispatch]);

    const handleCellCopyClick = (text) => {
        const textToCopy = text
        if (navigator.clipboard && navigator.clipboard.writeText) {
            navigator.clipboard.writeText(textToCopy)
                .then(() => {
                    dispatch(onSuccessAlert(`"${textToCopy}" ${t('copied')}`))
                })
                .catch((err) => {
                    dispatch(onErrorAlert(`${t('copy failed')}`))
                });
        }

    };

    useEffect(() => {
        if(loading){
            setRowSelection({})
        }
    }, [loading]);

    const columns = [
        {
            accessorKey: 'ocpOwnerId',
            header: t('ownerId'),
            muiTableHeadCellProps: { 'data-testid': 'cargo-owner-table-header-owner-id' },
            size: COLUMN_WIDTH.ownerId,
            muiTableBodyCellProps: ({ cell }) => ({
                onDoubleClick: (event) => {
                    handleCellCopyClick(cell.getValue())
                },
            }),
        },
        {
            accessorKey: 'activeFlag',
            header: t('ProductPage.isActive'),
            muiTableHeadCellProps: { 'data-testid': 'cargo-owner-table-header-active-status' },
            size: 130,
            // Cell: ({cell}) => (
            //     <div>
            //         {activeArr.find(v => v.value === cell.getValue())?.label}
            //     </div>
            // )
            muiTableBodyCellProps: {
                align: "center",
            },
            Cell: ({ cell }) => {
                const status = activeArr.find(v => v.value === cell.getValue()) || {};

                return (
                    <Chip
                        label={status?.label}
                        size="small"
                        color={status.value === 'Y' ? 'success' : status.value === 'N' ? 'error' : status.value === 'T' ? 'default' : 'info'}
                        sx={{
                            height: 18,
                            fontSize: 10,
                            fontWeight: 900,
                            ...(status.value === 'T' && { backgroundColor: '#374151', color: '#fff' }),
                        }}
                    />
                );
            },
        },
        {
            accessorKey: 'paymentTerm',
            header: t('CustomerPage.Payment Term'),
            muiTableHeadCellProps: { 'data-testid': 'cargo-owner-table-header-payment-term' },
            size: 137,
            muiTableBodyCellProps: ({ cell }) => ({
                onDoubleClick: (event) => {
                    handleCellCopyClick(cell.getValue())
                },
            }),
        },
        {
            accessorKey: 'invoiceTerm',
            header: t('CustomerPage.Invoice Term'),
            muiTableHeadCellProps: { 'data-testid': 'cargo-owner-table-header-invoice-term' },
            size: 180,
            Cell: ({cell, row}) => (
                <div>{getInvoiceTermLabel(cell.getValue() || row.original?.settlementPeriod)}</div>
            ),
            muiTableBodyCellProps: ({ cell, row }) => ({
                onDoubleClick: () => handleCellCopyClick(
                    getInvoiceTermLabel(cell.getValue() || row.original?.settlementPeriod)
                )
            }),
        },
        {
            accessorKey: 'accountManager',
            header: t('CustomerPage.Account Manager'),
            muiTableHeadCellProps: { 'data-testid': 'cargo-owner-table-header-account-manager' },
            size: 155,
            muiTableBodyCellProps: ({ cell }) => ({
                onDoubleClick: (event) => {
                    handleCellCopyClick(cell.getValue())
                },
            }),
        },
        {
            accessorKey: 'companyName',
            header: t('SignUpPage.Company Name'),
            size: 145,
            muiTableBodyCellProps: ({ cell }) => ({
                onDoubleClick: (event) => {
                    handleCellCopyClick(cell.getValue())
                },
            }),
        },
        {
            accessorKey: 'userName',
            header: t('CustomerPage.Owner User Name'),
            size: 160,
            muiTableBodyCellProps: ({ cell }) => ({
                onDoubleClick: (event) => {
                    handleCellCopyClick(cell.getValue())
                },
            }),
        },

        {
            accessorKey: 'omsOwnerType',
            header: t('CustomerPage.OMS Owner Type'),
            size: 155,
            muiTableBodyCellProps: ({ cell }) => ({
                onDoubleClick: (event) => {
                    handleCellCopyClick(cell.getValue())
                },
            }),

        },
        {
            accessorKey: 'ownerDesc1',
            header: t('CustomerPage.Description 1'),
            muiTableHeadCellProps: { 'data-testid': 'cargo-owner-table-header-description-1' },
            size: 130,
            muiTableBodyCellProps: ({ cell }) => ({
                onDoubleClick: (event) => {
                    handleCellCopyClick(cell.getValue())
                },
            }),
        },
        {
            accessorKey: 'ownerDesc2',
            header:  t('CustomerPage.Description 2'),
            muiTableHeadCellProps: { 'data-testid': 'cargo-owner-table-header-description-2' },
            size: 130,
            muiTableBodyCellProps: ({ cell }) => ({
                onDoubleClick: (event) => {
                    handleCellCopyClick(cell.getValue())
                },
            }),
        },

        {
            accessorKey: 'financerEmail',
            header: t('CustomerPage.Financer Email'),
            muiTableHeadCellProps: { 'data-testid': 'cargo-owner-table-header-financer-email' },
            size: 150,
            muiTableBodyCellProps: ({ cell }) => ({
                onDoubleClick: (event) => {
                    handleCellCopyClick(cell.getValue())
                },
            }),
        },
        {
            accessorKey: 'noteText',
            header: t('CustomerPage.Note Text'),
            muiTableHeadCellProps: { 'data-testid': 'cargo-owner-table-header-note-text' },
            size: 150,
            muiTableBodyCellProps: ({ cell }) => ({
                onDoubleClick: (event) => {
                    handleCellCopyClick(cell.getValue())
                },
            }),
        },
    ]
    

    const saveFormData = () => {
        let formData = {}
        formData.isActive = isActive ? isActive.value : ''
        formData.condition = value
        formData.pageNum = (pagination.pageIndex + 1)
        formData.pageSize = pagination.pageSize
        formData.language = languageSelect
        if (LocalStorage.getItem('username')) {
            formData.userName = LocalStorage.getItem('username')
        } else {
            return null
        }

        return formData
    }


    useEffect(()=>{


        if(ownerValue){
            const axiosPost = async () => {
                await dispatch(ownerSelected({condition: ownerValue, userName: LocalStorage.getItem('username')}, (data)=>setOwnerList(data)))
            }
            axiosPost().then()
        } else {
            setOwnerList([])
        }
    },[ownerValue])

    const onError = (msg, code) => {
        dispatch(onErrorAlert(msg))
        setExportLoading(false)
        setLoading(false)
        if (code === 401) {
            dispatch(Logout(noop))
            nav('/')
        }
    }

    const onSearchSuccess = (data) => {
        setTotal(data?.total ? data?.total:0)
        setData(data?.rows ? data?.rows.map((item, index) => {
            return { ...item, id: uuidv4() };
        }):[])
        setLoading(false)

    }


    useEffect(() => {

        let formData = {}
        if (saveFormData()) {
            formData = saveFormData()
        } else {
            return nav('/')
        }

        if(initialLoad.current){
            const axiosPost = async () => {

                setLoading(true)
                await dispatch(ownerFilter(formData, onSearchSuccess, onError))
            }
            checkPermission(PERMISSION_DICT.CustomerCargoList) && !loading && axiosPost().then()

            initialLoad.current = false
        } else if (isEqual(lastPayloadRef.current, formData) && !initialLoad.current) {
            return; // 如果 payload 相同，跳过请求
        } else {
            const axiosPost = async () => {

                setLoading(true)
                await dispatch(ownerFilter(formData, onSearchSuccess, onError))
            }
            checkPermission(PERMISSION_DICT.CustomerCargoList) && !loading && axiosPost().then()

            initialLoad.current = false
        }


        // 如果不同，更新 lastPayloadRef 并发送请求
        lastPayloadRef.current = formData;



    }, [pagination.pageIndex, pagination.pageSize, triggerFetch,languageSelect]);



    useEffect(() => {
        setPagination((prev) => ({ ...prev, pageIndex: 0 }));
        setTriggerFetch((prev) => !prev);
    }, [isActive,  value, owner]);


    const handleReset = () => {
        setOwner([])
        setCondition('')
        setIsActive(null)
        setPagination((prev) => ({ ...prev, pageIndex: 0 }));
        setTriggerFetch((prev) => !prev);
    }

    const csvConfig = mkConfig({
        fieldSeparator: ',',
        decimalSeparator: '.',
        useKeysAsHeaders: false,
        filename:`Customer_Information_${moment().format('YYYYMMDD')}`,
        columnHeaders: columns.map(({ accessorKey, header }) => ({
            key: accessorKey,
            displayLabel: header,
        }))
    });

    function CustomerToolbar() {

        const onLoadingClick = () => {
            const axiosPost = async () => {
                setLoading(true)
                await dispatch(ownerFilter(saveFormData(),onSearchSuccess,onError))
            }
            axiosPost().then()
        }

        const handleClick = async () => {
            setExportLoading(true)
            const rowData = data.filter(object=>Object.keys(rowSelection).filter(key => rowSelection[key]).includes(object?.id))
            const exportRows = rowData.map((row) =>
                columns.reduce((exportRow, column) => {
                    const key = column.accessorKey
                    let value = row?.[key]

                    if (key === 'invoiceTerm') {
                        value = getInvoiceTermLabel(row?.invoiceTerm || row?.settlementPeriod)
                    } else if (key === 'activeFlag') {
                        value = activeArr.find((item) => item.value === value)?.label || value
                    } else if (key === 'addTime' || key === 'editTime') {
                        value = value ? moment(value).format('YYYY-MM-DD') : ''
                    }

                    exportRow[key] = value === null || value === undefined ? '' : value
                    return exportRow
                }, {})
            )
            const csv = generateCsv(csvConfig)(exportRows)
            download(csvConfig)(csv);
            setExportLoading(false)
            dispatch(onSuccessAlert(`${t('Export')} Customer_Information_${moment().format('YYYYMMDD')} ${t('Successfully')}`))
        }

        return (
            <MDBox sx={{display:'flex',flexWrap:'wrap',maxWidth:'100%'}}>

                <LoadingButton
                    sx={{color:'info'}}
                    loading={exportLoading}
                    loadingPosition="start"
                    startIcon={<DownloadIcon />}
                    variant="text"
                    onClick={handleClick}
                    disabled={data.filter(object=>Object.keys(rowSelection).filter(key => rowSelection[key]).includes(object?.id)).length === 0}
                >
                    {t('Export')}
                </LoadingButton>
                <CurrentStateLoading onLoadingClick={onLoadingClick} loading={loading}/>
            </MDBox>
        );
    }


    const table = useMaterialReactTable({
        enableColumnActions: false,
        columns,
        data,
        enableSorting: true,
        enableColumnPinning: true,
        onColumnPinningChange:setColumnPinning,
        getRowId: (row) => (row.id),
        enableRowSelection: true,
        enableRowActions: true,
        displayColumnDefOptions: {
            'mrt-row-actions': {
                size: 60, //if using layoutMode that is not 'semantic', the columns will not auto-size, so you need to set the size manually
                grow: false,
            },
        },
        positionActionsColumn: 'last',
        renderRowActions: ({ row }) => (
            <MDBox sx={{ display: 'flex', flexWrap: 'nowrap' }}>
                <IconButton
                    data-testid="cargo-owner-preview-button"
                    color="primary"
                    disabled={!checkPermission(PERMISSION_DICT.CustomerCargoInfo)}
                    onClick={() => {
                        setTransferData(row.original);
                        setType('Preview');
                        setIsOpen(true)

                    }}>
                    <Icon>preview</Icon>
                </IconButton>
            </MDBox>

        ),
        enableRowNumbers: true,
        rowNumberDisplayMode: 'static',
        rowCount:total,
        paginationDisplayMode: 'pages',
        positionToolbarAlertBanner: 'bottom',
        enableColumnResizing: true,
        localization:languageSelect === 'en'?MRT_Localization_EN:languageSelect === 'zh'?MRT_Localization_ZH_HANS:MRT_Localization_FR,
        enableStickyHeader: true,
        enableStickyFooter: true,
        manualPagination: true,
        enableDensityToggle: false,
        enableBatchRowSelection: true,
        initialState: {
            density: 'compact',
            // columnVisibility: {
            //     lotId: false,
            //     alternativeId:false,
            //     financerEmail:false,
            //     noteText:false,
            //     ownerDesc2:false
            // },
        },
        onPaginationChange:setPagination,
        state: {
            pagination,
            rowSelection,
            isLoading:loading,
            showLoadingOverlay:false,
            showSkeletons:loading,
            showAlertBanner:false,
            columnPinning,
            columnVisibility
        },
        onColumnVisibilityChange:setColumnVisibility,
        onRowSelectionChange:setRowSelection,
        muiPaginationProps: {
            rowsPerPageOptions: [50, 100, 200],
            showFirstButton: true,
            showLastButton: true,
            color: 'primary',
            shape: 'rounded',
            showRowsPerPage: true,
            size:'small',
        },
        muiTableBodyCellProps:({ table }) => ({

            sx: (theme) => ({
                height:'30px',
            }),
            onClick: (event) => { event.preventDefault();}
        }),
        muiTableContainerProps: ({ table }) => ({
            sx: {
                maxHeight: table.getState().isFullScreen ?  undefined:tableHeight,
            },
        }),
        renderTopToolbarCustomActions: CustomerToolbar,
        muiTopToolbarProps:{
            sx: (theme) => ({
                maxWidth:'100%',
                background: theme.palette.background.table,
                padding:'0px',
                '& > div': {
                    padding: '0px',
                },
                '& > div:nth-of-type(2)': {
                    display:'flex',
                    flexWrap:'wrap'
                },
            }),
        },
        muiBottomToolbarProps:{sx: (theme) => ({backgroundColor:`${theme.palette.background.card} !important`})},
        muiTablePaperProps:{sx:
                {
                    boxShadow:'none',
                    '& > div:nth-of-type(1)': {
                        minHeight: '0', // 或者 'auto'
                    },
                }
        },
        muiSearchTextFieldProps:{
            placeholder: 'Search current page...',
        }



    });


    return (<React.Fragment>
        <Fade in={true} mountOnEnter unmountOnExit >
            <MDBox pt={2} pb={3}>
                <Grid container spacing={6}>
                    <Grid item xs={12}>
                        <Card>
                            <MDBox sx={{display: 'flex', justifyContent: 'center',overflow: 'auto'}}>
                                <Grid container xs={12} px={4} pt={0} spacing={2} alignItems={'flex-end'}>
                                    <Grid item xs={12} md={6} >
                                        <MDBox>
                                            <FormControl fullWidth >
                                                <MDInput
                                                    label= {t('CustomerPage.Search By Owner ID, Cargo Owner description')}
                                                    value={condition}
                                                    onChange={(e) => setCondition(e.target.value)}
                                                    variant={'standard'}
                                                />
                                            </FormControl>
                                        </MDBox>
                                    </Grid>
                                    <Grid item xs={12} md={4} >
                                        <MDBox>
                                            <FormControl fullWidth >
                                                <Autocomplete
                                                    required
                                                    disablePortal={false}
                                                    options={activeArr}
                                                    sx={{'& .MuiAutocomplete-inputRoot':{padding:0.05}}}
                                                    getOptionLabel={(option) => `${option?.label}`}
                                                    isOptionEqualToValue={(option, value) => option?.id === value?.id}
                                                    value={isActive}
                                                    onChange={(e, v) => setIsActive(v)}
                                                    renderInput={(params) =>
                                                        <MDInput
                                                            {...params}
                                                            label={t("ProductPage.Active")}
                                                            variant={'standard'}
                                                        />}
                                                />
                                            </FormControl>
                                        </MDBox>
                                    </Grid>
                                    <Grid item xs={12} md={1.5} sx={{display:'flex',justifyContent:'flex-end'}}>
                                        <MDButton sx={{marginLeft:1}} size={'small'} color="secondary" variant="outlined" startIcon={<CleaningServicesIcon />} onClick = {handleReset}>
                                            {t('reset')}
                                        </MDButton>
                                    </Grid>
                                </Grid>
                            </MDBox>
                            <MDBox pb={0} mt={0} px={4} ref={headerRef}>
                                <MaterialReactTable table={table} />
                            </MDBox>

                            <OwnerCargoPreviewer isOpen={isOpen} setIsOpen={setIsOpen} type={type} setType={setType} data={transferData}
                                                 setPageLoading={setLoading}
                                                 setPageList={setData}
                                                 setPageTotal={setTotal}
                                                 setRowSelection={setRowSelection}
                                                 saveFormData={saveFormData}
                            />
                            <Dialog
                                open={isAlertOpen}
                                onClose={() => setIsAlertOpen(false)}
                                aria-labelledby="alert-dialog-title"
                                aria-describedby="alert-dialog-description"
                                fullWidth
                                maxWidth={'sm'}
                            >
                                <DialogTitle id="alert-dialog-title">
                                    <div>{t("Are you sure?")}</div>
                                </DialogTitle>
                                <DialogContent>
                                    <DialogContentText id="alert-dialog-description">
                                        {`Do you really want to ${type.toLowerCase()} customer:`}
                                        <span style={{color: 'red', padding: '10px', fontWeight: 'bold'}}>{currentRow.customerId}</span>
                                        ? {t('This process cannot be undone')}
                                    </DialogContentText>
                                </DialogContent>
                                <DialogActions>
                                    <MDButton onClick={() => setIsAlertOpen(false)}>Disagree</MDButton>
                                    <MDButton onClick={async () => {
                                        let formData = {}
                                        formData.userName = LocalStorage.getItem('username')
                                        formData.customerId = currentRow.customerId

                                        if(type === 'Delete'){
                                            await dispatch(removeCustomer(formData, onDeleteSuccess, onError))
                                        }

                                        if(type === 'Close'){
                                            const axiosPost = async () => {

                                                await dispatch(change_Customer_Active(
                                                    {customerId:currentRow.customerId,
                                                        isActive:'N',
                                                        userName:LocalStorage.getItem('username')},
                                                    onCloseSuccess, onError))
                                            }
                                            axiosPost().then()
                                        }

                                    }} autoFocus sx={{color: 'red'}} variant='outlined'>
                                        Agree
                                    </MDButton>
                                </DialogActions>
                            </Dialog>



                        </Card>
                    </Grid>
                </Grid>
            </MDBox>
        </Fade>
    </React.Fragment>)
})

export default OwnerCargo
